import {Component, OnInit} from '@angular/core';
import {RequestHelper} from '@shared/helper/request.helper';
import {Router} from '@angular/router';
import {NavigationConstant} from '@shared/constant/navigation.constant';
import {MessageConstant} from '@shared/constant/message.constant';
import {environment} from '@environments/environment';
import {APIConstant} from '@shared/constant/api.constant';
import {DanamonModel} from '@shared/data/danamon-model';
import {DanamonStorage} from '@shared/storage/danamon.storage';

@Component({
    selector: 'app-payment-danamon',
    templateUrl: '../../payment.component.html',
    styleUrls: ['./payment-danamon.component.css']
})
export class PaymentDanamonComponent implements OnInit {

    vaNumber: any;
    customerName: any;
    binNo: any;
    binTitle: any;
    amount: any;
    billAmount: any;
    currency: any;
    isLoading: boolean = false;
    moduleName: string;
    imagePath: string;

    constructor(
        private apiService: RequestHelper,
        private storage: DanamonStorage,
        private router: Router,
        private request: DanamonModel,
    ) {
    }

    ngOnInit() {
        this.imagePath = this.storage.imagePath;
        this.moduleName = this.storage.moduleName;

        let inquiryData = this.storage.inquiryResult;
        if (inquiryData == null) {
            this.router.navigate([NavigationConstant.DANAMON_INQUIRY]);
        } else {
            let response = inquiryData.status;
            if (response === '000000') {
                this.vaNumber = inquiryData.vaNumber;
                this.customerName = inquiryData.customerName;
                this.binNo = inquiryData.binNo;
                this.binTitle = inquiryData.binTitle;
                this.currency = inquiryData.currency;
                this.amount = inquiryData.amount;
                this.billAmount = inquiryData.amount;
            } else if (response === '000101') {
                this.openDialog(MessageConstant.ALREADY_PAID);
            } else if (response === '000102') {
                this.openDialog(MessageConstant.EXPIRED);
            } else if (response === '000100') {
                this.openDialog(MessageConstant.NOT_FOUND);
            } else {
                this.openDialog(MessageConstant.CANNOT_PROCESS);
            }
        }
    }

    goBack() {
        this.router.navigate([NavigationConstant.DANAMON_INQUIRY]);
    }

    submitPayment() {
        this.isLoading = true;
        if (this.amount == null || this.amount.toString().length > 10) {
            this.isLoading = false;
            this.openDialog(MessageConstant.PAYMENT_FAILED);
        } else {
            this.request.vaNumber = this.vaNumber;
            this.request.customerName = this.customerName;
            this.request.binNo = this.binNo;
            this.request.binTitle = this.binTitle;
            this.request.currency = this.currency;
            this.request.billAmount = this.billAmount;
            this.request.payAmount = this.amount;

            this.apiService.post(environment.apiUrl + APIConstant.DANAMON_PAYMENT, JSON.stringify(this.request))
                .subscribe((data) => {
                        this.storage.paymentResult = data;
                        this.router.navigate([NavigationConstant.DANAMON_PAYMENT_RESULT]);
                    }, (err) => {
                        this.isLoading = false;
                        this.openDialog(MessageConstant.CANNOT_PROCESS);
                    }
                );
        }
    }

    home() {
        this.apiService.home();
    }

    openDialog(result) {
        this.apiService.openDialog(result, NavigationConstant.DANAMON_INQUIRY);
    }
}
